import React from 'react';
import styled from 'styled-components';
import { space, color, display } from 'styled-system';
import {
  MdAccessTime,
  MdAccountCircle,
  MdAdd,
  MdAddToPhotos,
  MdAnnouncement,
  MdApps,
  MdArrowBack,
  MdArrowDropDown,
  MdAssignment,
  MdAttachment,
  MdCalendarToday,
  MdCancel,
  MdCheck,
  MdCheckCircle,
  MdClose,
  MdCopyright,
  MdCreate,
  MdDevices,
  MdDevicesOther,
  MdDone,
  MdError,
  MdErrorOutline,
  MdExitToApp,
  MdFeedback,
  MdFileDownload,
  MdForward10,
  MdFullscreen,
  MdFullscreenExit,
  MdHome,
  MdInfo,
  MdInfoOutline,
  MdKeyboardArrowDown,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdKeyboardArrowUp,
  MdLibraryBooks,
  MdList,
  MdLock,
  MdLockOutline,
  MdMenu,
  MdNotifications,
  MdNotificationsNone,
  MdPause,
  MdPerson,
  MdPhone,
  MdPictureAsPdf,
  MdPlayArrow,
  MdPlayCircleFilled,
  MdPlayCircleOutline,
  MdPrint,
  MdRemoveRedEye,
  MdReplay,
  MdReplay10,
  MdRestore,
  MdSearch,
  MdSettings,
  MdShop,
  MdSkipNext,
  MdSmartphone,
  MdSync,
  MdThumbDown,
  MdThumbDownOffAlt,
  MdThumbUp,
  MdThumbUpOffAlt,
  MdTimer,
  MdToc,
  MdTune,
  MdUnfoldMore,
  MdViewList,
  MdVolumeUp,
  MdWarning,
  MdLink,
  MdAttachFile,
  MdOutlineComment,
  MdListAlt,
  MdDateRange,
  MdRefresh,
  MdHelp,
  MdImportContacts,
  MdArrowDownward,
  MdEmojiEvents,
  MdFlag,
  MdCheckCircleOutline,
  MdDirectionsWalk,
  MdOutlineLocalFireDepartment,
} from 'react-icons/md';
import {
  FaFacebook,
  FaFacebookF,
  FaFacebookMessenger,
  FaInstagram,
  FaLinkedin,
  FaMediumM,
  FaRegClock,
  FaRegStar,
  FaTwitter,
  FaTwitterSquare,
  FaYoutube,
  FaCircle,
} from 'react-icons/fa';
import {
  FaRegFaceLaugh,
  FaRegFaceSmile,
  FaRegFaceFrown,
  FaRegFaceFrownOpen,
} from 'react-icons/fa6';
import { IoMdCheckmark } from 'react-icons/io';
import { CgNotes } from 'react-icons/cg';
import { BiUserCircle, BiPurchaseTag } from 'react-icons/bi';
import {
  RiAccountCircleLine,
  RiQrScan2Line,
  RiHistoryFill,
  RiBook2Fill,
  RiBook2Line,
  RiInformationLine,
} from 'react-icons/ri';
import { SiTiktok } from 'react-icons/si';
import { AiFillGift, AiFillFire } from 'react-icons/ai';
import { BsFillQuestionCircleFill, BsExclamationCircle } from 'react-icons/bs';
import { FcApproval, FcIdea } from 'react-icons/fc';

import {
  Forum,
  Slide,
  Video,
  Correct,
  Incorrect,
  Achieve,
  ArticleType,
  LiveCodingType,
  QuizType,
  VideoPlayerType,
  NoteBoardType,
  PDFType,
  GradedExamType,
  Loading,
  Medal,
  GradedExamTimer,
  AssignmentIcon,
  Email,
} from './SkooldioSVGIcons';
import { VideoLibrary, Exit } from './PaasSVGIcons';
import {
  ImageUpload,
  QuestionMarkPersonIcon,
  EmptyStateClearIcon,
  ClearHeaderIcon,
  OnlineSolutionIcon,
  EmptyOnlineSolutionIcon,
  EmptyOnlineSolutionInCourseIcon,
} from './AnywhereSVGIcons';

const ICON_LIST = {
  ACCOUNT_CIRCLE: MdAccountCircle,
  ADD_TO_PHOTO: MdAddToPhotos,
  APPS: MdApps,
  ARROW_DOWN: MdKeyboardArrowDown,
  ARROW_LEFT: MdArrowBack,
  ARROW_RIGHT: MdKeyboardArrowRight,
  ARROW_UP: MdKeyboardArrowUp,
  ATTACHMENT: MdAttachment,
  BACK: MdKeyboardArrowLeft,
  CALENDAR_OUTLINED: MdCalendarToday,
  CALENDAR_DATE_RANGE: MdDateRange,
  CHECK_CIRCLE: MdCheckCircle,
  CHECK: IoMdCheckmark,
  CLOCK_CIRCLE: MdAccessTime,
  CLOCK_OUTLINED: FaRegClock,
  CLOSE_CIRCLE: MdCancel,
  CLOSE: MdClose,
  COPYRIGHT: MdCopyright,
  DANGER: MdError,
  DONE: MdDone,
  DOWNLOAD: MdFileDownload,
  DROPDOWN: MdArrowDropDown,
  EYE: MdRemoveRedEye,
  FEEDBACK: MdFeedback,
  FILL_GIFT: AiFillGift,
  FILL_FIRE: AiFillFire,
  FORUM: Forum,
  IMAGE_UPLOAD: ImageUpload,
  QUESTION_MARK_PERSON_ICON: QuestionMarkPersonIcon,
  EMPTY_STATE_CLEAR_ICON: EmptyStateClearIcon,
  CLEAR_HEADER_ICON: ClearHeaderIcon,
  ONLINE_SOLUTION_ICON: OnlineSolutionIcon,
  EMPTY_ONLINE_SOLUTION_ICON: EmptyOnlineSolutionIcon,
  EMPTY_ONLINE_SOLUTION_IN_COURSE_ICON: EmptyOnlineSolutionInCourseIcon,
  INFO: MdInfo,
  INFO_OUTLINED: MdInfoOutline,
  LIBRARY_BOOK: MdLibraryBooks,
  LIST: MdViewList,
  LINK: MdLink,
  LOADING: Loading,
  LOG_OUT: MdExitToApp,
  EXIT: Exit,
  MENU_BURGER: MdMenu,
  MENU_EXPAND_LESS: MdKeyboardArrowUp,
  MENU_EXPAND_MORE: MdKeyboardArrowDown,
  NEXT: MdKeyboardArrowRight,
  NOTIFICATION_OUTLINED: MdNotificationsNone,
  NOTIFICATION: MdNotifications,
  OTHER_DEVICE: MdDevicesOther,
  PAAS_OTHER_DEVICE: MdDevices,
  PERSON: MdPerson,
  PHONE: MdPhone,
  QRSCANNER: RiQrScan2Line,
  REPORT: MdAnnouncement,
  RESTORE: MdRestore,
  SEARCH: MdSearch,
  SETTINGS: MdSettings,
  SMART_PHONE: MdSmartphone,
  SORT_DOWN: MdUnfoldMore,
  SORT_UP: MdUnfoldMore,
  TAG: BiPurchaseTag,
  TIMER: MdTimer,
  TUNE: MdTune,
  USER_OUTLINED: BiUserCircle,
  WARNING: MdWarning,
  ATTACH_FILE: MdAttachFile,
  COMMENT: MdOutlineComment,
  ASSIGNMENT_STATUS: MdListAlt,
  HELP: MdHelp,
  IMPORT_CONTACTS: MdImportContacts,
  ASSIGNMENT: MdAssignment,
  ACCOUNT_OUTLINED: RiAccountCircleLine,
  CREATE: MdCreate,
  MD_CHECK: MdCheck,
  HOME: MdHome,
  LIKE_OUTLINED: MdThumbUpOffAlt,
  DISLIKE_OUTLINED: MdThumbDownOffAlt,
  NOTE: CgNotes,
  OUTLINE_NOTIFICATION: MdNotificationsNone,
  PDF: MdPictureAsPdf,
  SHOP: MdShop,
  REVERSE_CLOCK: RiHistoryFill,
  ERROR_OUTLINED: MdErrorOutline,
  TWITTER: FaTwitterSquare,
  TWITTER_BIRD: FaTwitter,
  TIKTOK: SiTiktok,
  YOUTUBE: FaYoutube,
  PRINT: MdPrint,
  ADD: MdAdd,
  REFRESH: MdRefresh,
  CIRCLE: FaCircle,

  // VideoSlide
  SLIDE: Slide,
  SYNC: MdSync,
  VIDEO: Video,
  FULL_SCREEN: MdFullscreen,
  EXIT_FULL_SCREEN: MdFullscreenExit,

  // Video
  BACKWARD: MdReplay10,
  FORWARD: MdForward10,
  PAUSE: MdPause,
  PLAY: MdPlayArrow,
  PLAY_CIRCLE_OUTLINE: MdPlayCircleOutline,
  REPLAY: MdReplay,
  SKIP_NEXT: MdSkipNext,
  VIDEO_PLAY_CIRCLE: MdPlayCircleFilled,
  VOLUME: MdVolumeUp,

  // QuizSimple
  CORRECT: Correct,
  INCORRECT: Incorrect,
  SCROLL_DOWN: MdArrowDownward,

  // Skooldio TOC
  ACHIEVE: Achieve,
  ARTICLE_TYPE: ArticleType,
  ASSIGNMENT_TYPE: AssignmentIcon,
  LIVECODING_TYPE: LiveCodingType,
  NOTEBOARD_TYPE: NoteBoardType,
  QUIZ_TYPE: QuizType,
  VIDEO_PLAYER_TYPE: VideoPlayerType,
  PDF_TYPE: PDFType,
  GRADED_EXAM_TYPE: GradedExamType,
  CONTENT_LIST: MdList,
  MEDAL: Medal,
  GRADED_EXAM_TIMER: GradedExamTimer,
  EMAIL: Email,

  // Review
  RATING_STAR_OUTLINED: FaRegStar,

  // Social
  DISLIKE: MdThumbDown,
  FACEBOOK_SQ: FaFacebook,
  FACEBOOK: FaFacebookF,
  INSTAGRAM: FaInstagram,
  LIKE: MdThumbUp,
  MEDIUM: FaMediumM,
  MESSENGER: FaFacebookMessenger,
  LINKEDIN: FaLinkedin,

  // Course
  LOCKED_OUTLINE: MdLockOutline,
  LOCKED: MdLock,
  TOC: MdToc,
  VIDEO_LIBRARY: VideoLibrary,

  // CLEAR+
  QUESTION_CIRCLE_FILL: BsFillQuestionCircleFill,
  BOOK_OUTLINE: RiBook2Line,
  BOOK_FILL: RiBook2Fill,
  FACE_LAUGH: FaRegFaceLaugh,
  FACE_SMILE: FaRegFaceSmile,
  FACE_FROWN: FaRegFaceFrown,
  FACE_FROWN_OPEN: FaRegFaceFrownOpen,

  // GuidedPractice
  IDEA: FcIdea,
  APPROVAL: FcApproval,

  // General
  INFORMATION: RiInformationLine,

  // MyPath
  FLAG: MdFlag,
  MEDAL_EVENTS: MdEmojiEvents,
  CHECK_CIRCLE_OUTLINE: MdCheckCircleOutline,
  WALK: MdDirectionsWalk,
  FIRE: MdOutlineLocalFireDepartment,
  EXCLAMATION_CIRCLE: BsExclamationCircle,
};

const Icon = ({ icon, ...props }) => {
  const IconComponent = icon;
  if (!IconComponent) return null;
  return <IconComponent {...props} />;
};

const StyledIcon = styled(Icon)`
  ${space};
  ${color};
  ${display};
`;

StyledIcon.ICON_LIST = ICON_LIST;

export { ICON_LIST };
export default StyledIcon;
